module.exports = __webpack_public_path__ + "img/preview.40646e78.jpg";